/** Currency for court figures. A figure the backend cannot compute yet arrives as null. */
export const amount = (value: number | null | undefined) =>
  value == null ? 'Not ready' : value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
